import { useEffect, useState} from 'react';
import Template from './../../Template'
import * as SG from '../../../style/Styles'
import * as S from '../../../style/User'
import * as TXT from './../../../util/Texts'
import { useParams } from "react-router-dom"
import * as UserService from './../../../services/User.service'
import { ERROR_ALERT, SUCCESS_ALERT } from './../../../util/AlertsMsg'
import { IUser } from '../../../interfaces/IUser';

export default function UserForm() {

  let { id }                              = useParams()
  const [isEdit, setIsEdit]               = useState<boolean>(false)
  const [registration, setRegistration]   = useState<string>('')
  const [name, setName]                   = useState<string>('')
  const [department, setDepartment]       = useState<string>('')
  const [cs, setCs]                       = useState<string>('')
  const [idUser, setIdUser]               = useState<string>('')
  const [typeUser, setTypeUser]           = useState<string>('')
  const [plants, setPlants]               = useState<string[]>([])
  const [countries, setCountries]         = useState<any[]>([])
  const [countryId, setCountryId]         = useState<string | number>('')

  const getCs = async () => {

    const result = await UserService.GetCs()
  
    if (result.data && result.data.status) 
      setPlants(result.data.plants)

    return
  }

  const getDataUser = async () => {

    setIsEdit(true)

    const result = await UserService.GetInfoUser(id)
  
    if (result.data && result.data.status) {
      const userData = result.data.user

      setRegistration(userData.register)
      setName(userData.name)
      setDepartment(userData.department)
      setCs(userData.cs)
      setIdUser(userData.id)
      setTypeUser(userData.profile_id)
      setCountryId(userData.country_id ?? '')

    } else {
      ERROR_ALERT(TXT.WRONG_TRY_AGAIN)
    }

    return
  }

  const resetPass = async()=>{

    const result = await UserService.ResetPassUser(idUser)
  
    if (result.data && result.data.status) {
      SUCCESS_ALERT(result.data.message)
    } else {
     
      try {
        ERROR_ALERT(result.response.data.message)
      } catch (error) {
        console.warn(error)
        ERROR_ALERT(TXT.WRONG_TRY_AGAIN)
      }
    }

    return
  }

  const handleSend = async () => {

    let errorMsg = []

    if (registration.trim() === '') 
      errorMsg.push(TXT.REGISTER)

    if (name.trim() === '') 
      errorMsg.push(TXT.NAME)

    if (department.trim() === '') 
      errorMsg.push(TXT.DEPARTMENT)

    if (cs.trim() === '') 
      errorMsg.push(TXT.PLANT)

    if (typeUser === '') 
        errorMsg.push(TXT.USER_TYPE)

    if (errorMsg.length > 0) {
      let allFilt = errorMsg.join(', ')
      let msg = errorMsg.length === 1 ? `${TXT.FIELD} ${allFilt} ${TXT.IS_REQUIRED}` : `${TXT.FIELDS} ${allFilt} ${TXT.ARE_REQUIRED}`
      ERROR_ALERT(msg)
      return false
    }

    let result;
    const dataUser:IUser = {
      id: idUser, 
      register: registration, 
      name: name, 
      department: department, 
      cs: cs, 
      profile_id: typeUser,
      country_id: countryId === '' ? undefined : Number(countryId)
    }

    if (isEdit)
      result = await UserService.UpdateUser(dataUser)
    else
      result = await UserService.CreateUser(dataUser)
  
    if (result.data && result.data.status) {

      SUCCESS_ALERT(result.data.message)

    } else {
     
      try {
        ERROR_ALERT(result.response.data.message)
      } catch (error) {
        console.warn(error)
        ERROR_ALERT(TXT.WRONG_TRY_AGAIN)
      }

    }

    return
  }

  useEffect(()=>{

    getCs()

    const storedCountries = localStorage.getItem('app_countries')
    if (storedCountries) {
      setCountries(JSON.parse(storedCountries))
    }

    if (id !== undefined)
      getDataUser()

  }, [])

  return (
    <Template>
      <SG.PADD>
        <S.BoxFormInteral className='formUser'>

          <SG.Title style={{textAlign:'center'}}> {isEdit ? TXT.EDIT_USER : TXT.NEW_USER}</SG.Title>
          <SG.Div className='inputsForms'>
            <SG.InputInternal 
              name='register'
              className='upperCase'
              value={registration}
              placeholder={TXT.REGISTER}
              onChange={(e)=> {setRegistration(e.target.value)}}
            />

            <SG.InputInternal 
              name='name'
              className='upperCase'
              value={name}
              placeholder={TXT.NAME}
              onChange={(e)=> {setName(e.target.value)}}
            />

            <SG.InputInternal 
              name='department'
              className='upperCase'
              value={department}
              placeholder={TXT.DEPARTMENT}
              onChange={(e)=> {setDepartment(e.target.value)}}
            />

            <SG.SelectInternal placeholder={TXT.CS} onChange={(e)=> {setCs(e.target.value)}} value={cs}>
              <SG.Option value="">{TXT.SELECT_PLANT}</SG.Option>
              { plants.length && plants.map((p:string, i:number) => (
                <SG.Option key={i} >{p}</SG.Option>
              ))}
            </SG.SelectInternal>

            <SG.SelectInternal onChange={(e)=> {setTypeUser(e.target.value)}} value={typeUser}>
              <SG.Option value="">{TXT.SELECT_USER_TYPE}</SG.Option>
              <SG.Option value="2">{TXT.ADMIN}</SG.Option>
              <SG.Option value="3">{TXT.COMUM}</SG.Option>
            </SG.SelectInternal>

            <SG.SelectInternal className='upperCase' onChange={(e)=> {setCountryId(e.target.value)}} value={countryId}>
              <SG.Option value="">{TXT.COUNTRY}...</SG.Option>
              { countries.length > 0 && countries.map((c:any, i:number) => (
                <SG.Option key={i} value={c.id}>{c.name}</SG.Option>
              ))}
            </SG.SelectInternal>
          </SG.Div>

          {isEdit && <S.RESETPASS onClick={resetPass}>{TXT.RESET_PASSWORD}</S.RESETPASS> }

          <SG.Div className='boxbutton'>
            <SG.PrimaryButtom onClick={handleSend}> <i className="fa-regular fa-floppy-disk"></i> {TXT.SAVE} </SG.PrimaryButtom>
          </SG.Div>

          </S.BoxFormInteral>
      </SG.PADD>
    </Template>
  );
}
